import email from "./email/en";
import reminders from "./reminders/en";
import settings from "./settings/en";
import program from "./program/en";
import pdfConstructor from "./pdfConstructor/en";
import pages from "./pages/en";

export default {
    "mainMenu.event": "Event",
    "mainMenu.offline": "Offline",
    "mainMenu.tickets": "Tickets",
    "mainMenu.chats": "Chats",
    "mainMenu.questions": "Questions for participants",
    "mainMenu.polls": "Polls",
    "mainMenu.quizzes": "Quizzes",
    "mainMenu.shop": "Prizes shop",
    "mainMenu.eventNotifications": "Event notifications",
    "mainMenu.emails": "Emails",
    "mainMenu.emails.globalSettings": "Global settings",
    "mainMenu.emails.password": "Authorization password",
    "mainMenu.emails.eventRegistration": "Event registration",
    "mainMenu.emails.eventAccessAllowed": "View approve",
    "mainMenu.emails.ticket": "Personal ticket",
    "mainMenu.emails.lettersConstructor": "Letters constructor",
    "mainMenu.emails.createLetterTemplate": "Creating a letter template",
    "mainMenu.emails.editLetterTemplate": "Edit a letter template",
    "mainMenu.emails.blocksEditor": "Block editor",
    "mainMenu.emails.calendar": "Calendar",
    "mainMenu.reminders": "Reminders",
    "mainMenu.edit.reminders": "Edit reminders",
    "mainMenu.clients": "Clients",
    "mainMenu.statistic": "Statistic",
    "mainMenu.statistic.visit": "Visit statistics",
    "mainMenu.statistic.stream.live": "Live statistic",
    "mainMenu.statistic.stream.record": "Record statistic",
    "mainMenu.statistic.download": "Download",
    "mainMenu.statistic.shop": "Prizes shop",
    "mainMenu.records": "Records",
    "mainMenu.pages": "Pages",
    "mainMenu.pages.edit": "Page edit",
    "mainMenu.banners": "Banners",
    "mainMenu.client_certificate": "Certificate",
    "mainMenu.client_certificate.settings": "Settings",
    "mainMenu.client_certificate.owners": "Owners",
    "mainMenu.accessByEmails": "Access by eMail",
    "mainMenu.accessPreModeration": "Clients",
    "mainMenu.presenceCheck": "Presence",
    "mainMenu.notifications": "Notifications",
    "mainMenu.activityTop": "Activity Top",
    "mainMenu.widgets": "Wigets",
    "mainMenu.widget.registration": "Registration",
    "mainMenu.widget.registrationConstructor": "Registration form",
    "mainMenu.widget.update": "Changing widget settings",
    "mainMenu.widget.player": "Player",
    "mainMenu.widget.platform-player": "New player",
    "mainMenu.registrations": "Registrations",
    "mainMenu.eventSettings": "Event settings",
    "mainMenu.eventSettings.commonSettings": "Common settings",
    "mainMenu.eventSettings.brandingSettings": "Branding settings",
    "mainMenu.eventSettings.authorization": "Authorization",
    "mainMenu.eventSettings.viewing-restriction": "Viewing Restriction",
    "mainMenu.eventSettings.loginAndRegistration": "Login and registration page",
    "mainMenu.eventSettings.playerSettings": "Player Settings (old)",
    "mainMenu.eventSettings.enablingModules": "Enabling modules",
    "mainMenu.schedule": "Schedule",
    "mainMenu.schedule.episodes": "Episode editor",
    "mainMenu.schedule.participants": "Participants",
    "mainMenu.schedule.programs": "Program constructor",
    "mainMenu.schedule.timetable": "Schedule constructor",
    "mainMenu.quizConstructor": "Quiz page constructor",
    "mainMenu.membersConstructor": "Members page constructor",
    "mainMenu.broadcastConstructor": "Broadcast page constructor",
    "mainMenu.hallsConstructor": "Halls page constructor",
    "mainMenu.defaultConstructor": "Page constructor",
    "mainMenu.lobbyConstructor": "Lobby page constructor",
    "mainMenu.shopConstructor": "Prizes shop page constructor",
    "mainMenu.profileConstructor": "Member profile page constructor",
    "mainMenu.hallsSettings": "Hall Settings",
    "mainMenu.pdfConstructor": "PDF constructor",
    "mainMenu.interactive": "Interactive",
    "mainMenu.interactive.pollsAndVoting": "Polls and voting in the halls",
    "mainMenu.interactive.managePollResult": "Manage poll results",

    "client.ban.button": "Block",
    "client.unban.button": "Unblock",
    "client.ban.confirm": 'Are you sure wonna ban user "{nickname}"?',
    "client.ban.success": "User {username} is banned",
    "client.unban.confirm": 'Are you sure wonna unblock user "{nickname}"?',
    "client.unban.success": "User {username} is unbanned",
    "client.ban.modal.title": "Banned users",
    "client.ban.modal.emptyList": "The list is empty",
    "message.control.show": "Show",
    "message.control.hide": "Hide",
    "message.control.delete": "Delete",
    "message.answer.button": "Answer",
    "message.submit.button": "Submit",
    "message.participationType.online": "From an online participant",
    "message.participationType.offline": "From the viewer in the hall",

    "placeholder.selectValue": "Select value",

    "role": "Role",
    "role.viewer": "Viewer",
    "role.moderator": "Moderator",
    "role.organizer": "Organizer",
    "role.speaker": "Speaker",
    "role.technical_support": "Technical Support",
    "role.change.success": "Participant's role successfully changed to {value}",

    "status": "Status",
    "status.approved": "Approved",
    "status.request": "Under moderation",
    "status.reject": "Refused",
    "status.change.success": "Participant status successfully changed to {value}",

    "field.change.error": "An error occurred, please try again",

    "participationType": "Participation type",
    "participationType.online": "Online",
    "participationType.offline": "Offline",
    "participationType.hybrid": "Online + Offline",

    "participants.clear_question": "Are you sure you want remove all participants?",
    "participants.removeMember": "Are you sure you want to remove this member?",

    "button.create": "Create",

    "label.poll.answerNumber": "Answers number",
    "label.poll.answerColors": "Color scheme",

    "poll.type.standard": "Standard",
    "poll.type.open": "Word cloud",
    "poll.type.rating": "Rating",

    "quiz.type.standard": "Standard",
    "quiz.type.rating": "Rating",
    "quiz.type.open": "Free Choice",

    "importExcel.modal.close": "Close",
    "importExcel.modal.confirm": "Confirm",
    "importExcel.modal.dontCloseWindow":
        "Do not close this window until the import is complete",
    "importExcel.modal.filesAdded": "Added {alreadyAdded} from {total}",
    "importExcel.modal.importError":
        "An error occurred while importing data for the following users:",
    "importExcel.modal.loadingIsComplete": "Loading is complete",
    "importExcel.modal.next": "Next",
    "importExcel.modal.table.column": "Column",
    "importExcel.modal.table.noColor": "Absent",
    "importExcel.modal.table.title": "Registration field COMDI",
    "importExcel.modal.table.list": "List",
    "importExcel.modal.table.rowNumber": "First line number",
    "importExcel.modal.title": "Mailing",
    "importExcel.modal.sendRegistrationLetter": "Send registration letter",
    "importExcel.modal.subtitle":
        "Select the column and first row number containing the required email addresses.",

    "episodes.clear_question": "Are you sure you want remove all episodes?",

    "spectators": "Spectators",

    ...email,
    ...reminders,
    ...settings,
    ...program,
    ...pdfConstructor,
    ...pages,
};
